import { localStore } from '@/services/local.storage';

export default function isAgent ({ next, store }){
    if(!store.getters.auth.loggedIn){
        return next({name:"Login"})
    }

    if(store.getters.auth.loggedIn && !store.getters.auth.isAgent){
        if(atob(localStore.getLocalStorage('role'))=='admin')
            return next({  name: 'Admin Dashboard'  });
        if(atob(localStore.getLocalStorage('role'))=='vendor')
            return next({  name: 'Vendor Dashboard'  });
    }
        return next()
}